import RideEstimateComponent from '../components/ride-estimate-component';

export default class RideEstimateController {

  constructor() {
    new RideEstimateComponent($('#rideEstimateComponent'));
  }
}
